// extracted by mini-css-extract-plugin
export default {"Contact":"PharmaSupportContact_Contact__F0yII"};